import { forwardRef, type Ref, type SVGProps } from "react";
const IconZillowMarkLegacySVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M20.85 9.65c-.08-.1-.14-.1-.27-.1A92.4 92.4 0 0 0 3 16.57V12L16 2l13.03 10v4.15a92 92 0 0 0-13.83 4 51.4 51.4 0 0 1 7.93-7.61.16.16 0 0 0 0-.21l-.517-.612c-.593-.703-1.443-1.711-1.763-2.068" />
    <path d="M9.72 26.86a.22.22 0 0 0 .28 0c4.84-2.44 15.45-5.53 19-6.12V30H3v-9.63a109 109 0 0 1 12.44-5.28 45.5 45.5 0 0 0-8.14 8.66c-.07.13-.07.17 0 .25z" />
  </svg>
);
const ForwardRef = forwardRef(IconZillowMarkLegacySVG);
ForwardRef.displayName = "IconZillowMarkLegacy";
export { ForwardRef as IconZillowMarkLegacy };
